import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";

import Panel from "common/components/Panel";
import Resource from "common/components/Resource";
import Pagination from "common/components/Pagination";
import * as datetime from "common/utils/datetime";
import {
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  TableFooter,
  Table,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DebouncedTextField from "common/components/DebouncedTextField";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusFilter: "",
      searchFilter: "",
    };
  }

  handleStatusFilterChange = (e) => {
    this.setState({ statusFilter: e.target.value });
  };

  handleSearchFilterChange = (value) => {
    this.setState({ searchFilter: value });
  };

  render() {
    const { classes, match, history } = this.props;
    const { statusFilter, searchFilter } = this.state;
    const queryParams = {};
    if (statusFilter) {
      queryParams.status = statusFilter;
    }
    if (searchFilter) {
      queryParams.owner_name_like = searchFilter;
    }

    return (
      <Panel title="Offers">
        <Grid container direction="row">
          {/* <Grid size={{ xs: 2 }}>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="status-filter">Status</InputLabel>
              <Select
                value={statusFilter}
                onChange={this.handleStatusFilterChange}
                input={<Input name="name" id="status-filter" />}
              >
                <MenuItem value="">
                  <em>All</em>
                </MenuItem>
                <MenuItem value="approved">Approved</MenuItem>
                <MenuItem value="change_request">Changes Requested</MenuItem>
                <MenuItem value="submitted">Submitted</MenuItem>
                <MenuItem value="rejected">Rejected</MenuItem>
              </Select>
            </FormControl>
          </Grid> */}
          <Grid size={{ xs: 4 }}>
            <DebouncedTextField
              className={classes.searchFilter}
              id="search"
              label="Submitted by"
              onChange={this.handleSearchFilterChange}
              delay={500}
              fullWidth
            />
          </Grid>
        </Grid>
        <Resource
          name="offers"
          queryParams={queryParams}
          render={(offers, { page, nextPage, prevPage }) => (
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Submitted By</TableCell>
                  <TableCell>Published</TableCell>
                  <TableCell>Start</TableCell>
                  <TableCell>End</TableCell>
                  {/* <TableCell>Status</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {offers.length ? (
                  offers.map((offer) => (
                    <TableRow hover key={offer.id}>
                      <TableCell>{offer.id}</TableCell>
                      <TableCell
                        className={classes.clickable}
                        onClick={() =>
                          history.push(`${match.url}/review/${offer.id}`)
                        }
                      >
                        {offer.name}
                      </TableCell>
                      <Resource
                        name={offer.business_id ? "businesses" : "buildings"}
                        resourceId={offer.business_id || offer.building_id}
                        render={(resource) => (
                          <TableCell>{resource.name}</TableCell>
                        )}
                      />
                      <TableCell>{datetime.full(offer.published_at)}</TableCell>
                      <TableCell>{datetime.full(offer.start_at)}</TableCell>
                      <TableCell>{datetime.full(offer.end_at)}</TableCell>
                      {/* <TableCell>
                        <OfferStatus status={offer.status} />
                      </TableCell> */}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6}>No additional data found.</TableCell>
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={6} className={classes.pagination}>
                    <Pagination
                      page={page}
                      nextPage={nextPage}
                      prevPage={prevPage}
                      items={offers}
                    />
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          )}
        />
      </Panel>
    );
  }
}

const styles = (theme) => ({
  clickable: {
    cursor: "pointer",
    color: "#000",
    textDecoration: "underline",
    fontWeight: "bold",
  },
  table: {
    minWidth: 700,
  },
  pagination: {
    textAlign: "right",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  searchFilter: {
    marginTop: theme.spacing(1),
  },
});

List.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withStyles(styles)(List);
